interface UmedsSuccessIconProps {
  width?: string;
  height?: string;
  className?: string;
}

export default function UmedsSuccessIcon({ width = '60', height = '60', className }: UmedsSuccessIconProps) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 61 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51.2115 8.78853C45.5539 3.1126 38.0104 0 30.0092 0C21.9896 0 14.4461 3.1126 8.78853 8.78853C3.1126 14.4461 0 21.9896 0 30.0092C0 38.0287 3.1126 45.5539 8.78853 51.2298C14.4461 56.8874 21.9896 60.0183 30.0092 60.0183C38.0287 60.0183 45.5539 56.9057 51.2298 51.2298C56.8874 45.5722 60.0183 38.0287 60.0183 30.0092C60 21.9896 56.8874 14.4461 51.2115 8.78853Z"
        fill="#042B37"
      />
      <path
        d="M26.0643 35.4354L20.1704 29.5416C19.0356 28.4067 17.1686 28.4067 16.0337 29.5416C14.8989 30.6764 14.8989 32.5434 16.0337 33.6782L23.9959 41.6404C25.1308 42.7752 26.9977 42.7752 28.1326 41.6404L44.6976 25.0754C45.8324 23.9406 45.8324 22.0736 44.6976 20.9388C43.5627 19.8039 41.6957 19.8039 40.5609 20.9388L26.0643 35.4354Z"
        fill="#FF9845"
      />
    </svg>
  );
}
